const _document = $(document);
const _window = $(window);
const windowWidth = _window.width();
const windowHeight = _window.height();

const html = $('html');
const body = $('body');
const main = $('#main');
const sidebar = $('#sidebar');

const responsive = windowWidth < 800
	? true
	: false

const offset = !responsive
	? windowHeight * 0.3
	: windowHeight * 0.01

/*  TOOLS  */

function appInit() {
	$('a[href]').each(function(){
		var _this = $(this);
		if((location.hostname === this.hostname || !this.hostname.length)
			&& _this.attr('href') != '#'
			&& _this.attr('href').includes('mailto:') != true){
			_this.data('location','internal')
		}else{
			_this.data('location','external')
		}
	}).on('click', function(e){
		var _this = $(this);
		if(_this.data('location') == 'internal'){
			e.preventDefault();
			html.addClass('is_leaving')
				.removeClass('special_project_slide sidebar_open')

			setTimeout(function(){
				window.location.href = _this.attr('href');
			},900)
		}
	});

	html.addClass('is_loaded');

	initLocalStorage();
	imageOptimization();

	if($('#newsletter').length && has_localstorage == true) {
		initNewsletter();
	}

	initTabs();
	initForms();
	initBand();
	faviconAnimate();
	initSidebarStacks();
	initResponsiveSidebar();

	switch(body.attr('id')) {
		case 'frontpage':
			initFrontpage();
			break;

		case 'product-index':
			initProductIndex();
			initSpecialProjects();

		case 'product-single':
			initProductSingle();
			break;

		case 'blog-single':
			initArticle();
			break;

		case 'cart':
			initCart();
			break;

		case 'page-information':
			initInformationPage();
			break;

		case 'account':
			initAccount();
			break;
	}
}
appInit();

function initLocalStorage(){
	var test_key = 'test',
		storage = window.sessionStorage;
	try{
		storage.setItem(test_key,'1');
		storage.removeItem(test_key);
		return localStorageName in win && win[localStorageName];
	}catch(e){
		if(e.code === DOMException.QUOTA_EXCEEDED_ERR && storage.length === 0){
			has_localstorage = false
		}else{
			has_localstorage = true
		}
	}
}

function imageOptimization() {
	if(window.devicePixelRatio > 1){
		html.addClass('is_retina');
	}
	if(windowWidth < 769){
		$('img[data-mobile]').each(function() {
			var img = $(this);
			if(img.attr('data-mobile') != ''){
				img.attr('data-no-retina','').attr('src',img.attr('data-mobile'))
			}
		});
	}
	if(windowWidth > 768){
		$('[data-desktop]').each(function() {
			var _this = $(this);
			_this.attr('src',_this.data('desktop'));
		})
	}
}

function retinafy() {
	var img_src = $(this).attr("src");
	if(img_src.indexOf("@2x") == -1){
  		new RetinaImage(this);
  	}
}

function scrollTo(id){
	let item = $(id);
	let offsetTop = item.data('stack-scroll')
		? item.data('stack-scroll')
		: item.offset().top

	main.animate({
		scrollTop: offsetTop - offset + 5
	},300);
}

function scrollToClick(event){
	event.preventDefault();
	scrollTo($(this).attr('data-scroll'));
}
$(document).delegate('[data-scroll]','click',scrollToClick)

function initForms() {
	var input = $('input[type="text"],input[type="email"],input[type="password"]'),
		textarea = $('textarea');
	$.merge(input,textarea).each(function() {
		$(this).attr('value','');
	})
	$.merge(input,textarea).on('keyup',function() {
		var _this = $(this);
		_this.attr('value',_this.val());
	});
	$('select').change(function() {
		$(this).addClass('selected');
	})
}

/*  TOOLS - END  */

function initNewsletter(){
	const newsletter = $('#newsletter');
	const newsletterClose = newsletter.find('#newsletter_close');
	const newsletterForm = newsletter.find('form');
	const newsletterEmail = newsletter.find('#newsletter-email');
	const newsletterNotice = newsletter.find('#newsletter-notice');
	let newsletterTimeNow = new Date().getTime();
	let newsletterTimeSetup = localStorage.getItem('newsletterTimeSetup');
	let newsletterPopKey = 'ccc_6969'

	if(newsletterTimeSetup === null){
		localStorage.setItem('newsletterTimeSetup', newsletterTimeNow);
	}else if(newsletterTimeNow - newsletterTimeSetup > 2*24*60*60*1000){
		localStorage.removeItem(`displayPop_${newsletterPopKey}`);
		localStorage.setItem('newsletterTimeSetup', newsletterTimeNow);
	}

	if(localStorage.getItem(`displayPop_${newsletterPopKey}`) != 'closed'){
		setTimeout(function(){
			html.addClass('newsletter_active');
		}, 2500);
	}

	newsletterClose.click(function(){
		html.removeClass('newsletter_active');
		localStorage.setItem(`displayPop_${newsletterPopKey}`, 'closed');
	});

	newsletterForm.submit(function(e) {
		e.preventDefault();

		$.ajax({
			type: newsletterForm.attr('method'),
			url: newsletterForm.attr('action'),
			data: newsletterForm.serialize(),
			cache: false,
			dataType: 'json',
			contentType: "application/json; charset=utf-8",
			error: function(err) { 
				newsletterEmail.addClass('error');
			},
			success: function(data) {
				if (data.result != "success") {
					newsletterEmail.addClass('error');
					newsletterNotice.slideDown().html(`<td><p>${data.msg}</p></td>`);
				} else {
					newsletterEmail.removeClass('error');
					newsletterForm.slideUp();
					newsletterNotice.slideDown().html(`<td><p>${data.msg}</p></td>`);
					localStorage.setItem(`displayPop_${newsletterPopKey}`, 'closed');
				}
			}
		});
	});
}

function initTabs() {
	const navigation = $('#navigation');
	const tabOverlap = $('#tab-overlap');

	$('#tab-collections li a').each(function() {
		let _this = $(this);

		if(window.location.href.includes(_this.attr('href'))) {
			_this.parent().addClass('active');
		}
	});

	let tabActive = navigation.find('.active');

	if(!responsive && tabActive.length) {
		tabOverlap.addClass(tabActive.closest('#tab-collections').length ? 'tab-overlap-collections' : '')
			.append(tabActive.clone()).css({
				'top': tabActive.offset().top,
			}).find('li').css({
				'width': tabActive.width(),
				'height': tabActive.height()
			});

		tabOverlap.show();
	}
}

function initSidebarStacks() {
	const stacks = sidebar.find('#stacks');
	const stacksHeight = stacks.height();
	const stackAnchors = $('[data-stack-anchor]');
	const stackTitleHeight = 28;
	const headerPullText = $('#header-pull_text');

	stackAnchors.each(function (){
      	const _this = $(this);

		_this.attr('data-stack-scroll', Math.floor(_this.offset().top));
	});

	$('.stack-bookmark[data-href]').click(function(e) {
		e.preventDefault();

		window.location.href = $(this).attr('data-href');
	});

	setTimeout(function() {
		stacks.addClass('active');
	}, 200);

  	function sidebarStacksScroll() {
		const scrollTop = main.scrollTop();
		const scrollTopOffset = scrollTop < 120
			? 110
			: Math.floor(scrollTop + offset)

		function moveStacksUp(stack) {
			let moveStack = sidebar.find(`[data-stack="${stack}"]`);

			if(!responsive) {
				moveStack.css('top',
					(moveStack.prevAll().length)*stackTitleHeight - moveStack.prevAll().length - 1
				)
			}
		}

		stackAnchors.each(function () {
			let _this = $(this);
			let _thisTop = parseInt(_this.attr('data-stack-scroll'));
			let _thisNext = _this.nextAll('[data-stack-anchor]').first();
			let _thisNextTop = _thisNext.attr('data-stack-scroll') === undefined
				? Infinity
				: parseInt(_thisNext.attr('data-stack-scroll'));

			if (scrollTopOffset > _thisTop && scrollTopOffset < _thisNextTop) {
				let activeStack = sidebar.find(`[data-stack="${_this.attr('data-stack-anchor')}"]`);

				activeStack.nextAll().each(function() {
					let stackNext = $(this);

					stackNext.removeClass('active active_prev');

					if(!responsive) {
						let stackOffset = $('#sidebar-stack-sides').length 
							? 0 
							: 1

						stackNext.css('top',
							stacksHeight - (stackNext.nextAll().length + stackOffset)*stackTitleHeight + stackNext.nextAll().length);
					}
				});

				activeStack.addClass('active');
				activeStack.prevAll().addClass('active_prev')
					.removeClass('active')

				moveStacksUp(_this.attr('data-stack-anchor'));

				if(responsive) {
					if(headerPullText.length) {
						headerPullText.text(activeStack.find('.stack-title').text());
					}
				}else{
					activeStack.find('.stack-content').slideDown(200);
					activeStack.siblings().find('.stack-content').slideUp(200);
				}
			}else if(scrollTopOffset > _thisTop) {
				moveStacksUp(_this.attr('data-stack-anchor'));
			}
		});
  	}
    sidebarStacksScroll();
    main.scroll(sidebarStacksScroll);
}

function initProductIndex() {
	$('.product-title_stylize').each(function (){
		let _this = $(this);
		let _thisTextSplit = _this.text().split(/_(.+)/)

		_this.html(`<span class="cr-red">${_thisTextSplit[0]}</span>_${thisTextSplit[1]}`)
	});
}

function initProductSingle() {
	const productForm = $('#product-form');
	const productPriceTd = $('#product-price td');

	_document.on('click', '.variant-label', function() {
		$(this).siblings('ul').slideToggle(200);

	}).on('click', '.product-variant li', function() {
		let _li = $(this);

		_li.toggleClass('active').siblings().removeClass('active');

		productPriceTd.html(`<span class="price-purchase">${_li.attr('data-price')}</span>`);
		$('[name="id"]').val(_li.attr('data-id'));

	}).on('click', '[name="add"]', function(e) {
		e.preventDefault();

		if($('[name="id"]').val()) {
			triggerCart();
		}else{
			let productVariant = $('.product-variant');

			productVariant.addClass('error');
			setTimeout(function(){
				productVariant.removeClass('error');
			}, 1200);
		}
	});

	function triggerCart() {
		const productAdd = $('[name="add"]');
		const sidebarCart = $('#sidebar-cart');
		const headerCart = $('#header-cart');
		const sidebarCartqty = sidebarCart.find('#cart-qty');
		const sidebarCartPrice = sidebarCart.find('#cart-price');

		let productQTY = 1

		productAdd.attr('value', 'Adding...');

		$.post(`/cart/add.js?id=${$('[name="id"]').val()}&quantity=${productQTY}`).always(function() {
			$.ajax({
				url: '/cart',
				dataType: 'html',
				success: function(data) {
					productAdd.attr('value', 'Added!');
					setTimeout(function() {
						productAdd.attr('value', 'Add to cart');
					}, 2000);

					if(headerCart.hasClass('no-items')) {
						headerCart.fadeIn(200);
						setTimeout(function() {
							headerCart.removeClass('no-items');
						}, 200);
					}
					headerCart.find('span').text(parseInt(headerCart.find('span').text()) + productQTY);

					if(sidebarCart.hasClass('no-items')) {
						sidebarCart.slideDown(200);
						setTimeout(function() {
							sidebarCart.removeClass('no-items');
						}, 200);
					}
					sidebarCartqty.text(parseInt(sidebarCartqty.text()) + productQTY);
					sidebarCartPrice.text(`
						$
						${parseInt(sidebarCartPrice.text().replace('$', '')) +  
						parseInt($('#product-price').find('.price-purchase').text().replace('$', ''))}
					`)
				}
			});
		});
	}

	_document.on('click', '.expandable h3', function(){
		$(this).closest('.expandable').toggleClass('active')
			.find('.expandable-content').slideToggle(200);
	});

	if(responsive) {
		const productImages = $('#product-images');
		const productImagesScroll = productImages.find('.width');

		$('#product-info-responsive .width').append(sidebar.find('#product-info > *').clone()).find('#product-description').remove();
		productImages.after(`<div id="product-images-nav">
			${Array(productImages.find('img').length).join(0).split(0).map((item, i) => `
				<button data-image="${i}"></button>
			`).join('')}
		</div>`)

		productImagesScroll.scroll(function(){
			let scrollLeft = productImagesScroll.scrollLeft();

			$(`[data-image=${parseInt(scrollLeft/windowWidth)}]`).addClass('active')
				.siblings().removeClass('active');
		});

		const productImagesCloned = productImages.clone().addClass('cloned');

		body.append(productImagesCloned.append('<button id="product-images_close"></button>'));

		productImages.click(function() {
			const productImagesActive = $(productImagesCloned.find('.image')[$('#product-images-nav .active').index()]);

			html.addClass('product_images_zoomed');
			if($('#product-images-nav .active').index() > 0) {
				console.log(productImagesActive.position().left);
				productImagesCloned.find('.width').animate({
					scrollLeft: productImagesActive.position().left
				}, 1);
			}
		});

		_document.on('click', '#product-images_close', function() {
			html.removeClass('product_images_zoomed');

			setTimeout(function(){
				productImagesCloned.find('.width').animate({
					scrollLeft: 0
				}, 1)
			}, 600);
		});

		_document.on('click', '[data-image]', function() {
			let _this = $(this);

			_this.addClass('active')
				.siblings().removeClass('active');

			productImagesScroll.css('scroll-snap-type', 'none').animate({
				scrollLeft: _this.index()*windowWidth + 1
			}, 300);

			setTimeout(function() {
				productImagesScroll.css('scroll-snap-type', 'x mandatory');
			}, 301);
		});

		$('[data-image]:first-of-type').trigger('click');
		sidebar.find('#product-info > *:not(.table)').remove();
		sidebar.find('#product-info > .table > tbody > tr:not(#product-description)').remove();
	}
}

function initCart() {
	$('select[name="quantity"]').change(function(){

		window.location.href = $(this).data('update') + $(this).val();
	});

	$('[data-update]').on('click', function(e){
		e.preventDefault();

		window.location.href = $(this).data('update')
	});

	if(responsive) {
		$('#cart-actions-responsive').append(sidebar.find('#cart-actions').clone());
	}
}

function faviconAnimate(){
  const favicon = $("link[rel='icon']");
  const faviconLink = favicon.attr('href');
  let count = 1;

  setInterval(function(){
  	favicon.attr('href', faviconLink.replace('-1', `-${count}`));

    if(count == 4){
      setTimeout(function(){
        count = 1
      },1000)
    }else{
      count++
    }
  },1000);
}

function initFrontpage() {
	const calligraphyContainer = $('#calligraphy-container');
	const calligraphy = calligraphyContainer.find('.calligraphy');
	const translateOffset = [37.5, 12.5, -12.5, -37.5];

	$('#frontpage-video').fitVids();

	calligraphy.on('click', function() {
		let _this = $(this);

		if(responsive) {
			if(_this.hasClass('active')) {
				calligraphyContainer.removeClass('calligraphy_expanded');
			}else{
				calligraphyContainer.addClass('calligraphy_expanded')
					.css({
						'-webkit-transform': 
							`translate(calc(-50% + ${translateOffset[_this.index()]}vh), -50%) rotate(0deg)`,
						'transform': 
							`translate(calc(-50% + ${translateOffset[_this.index()]}vh), -50%) rotate(0deg)`
					});
			}
		}else {
			if(_this.hasClass('active')) {
				calligraphyContainer.css({
					'-webkit-transform': 
						`translate(-50%, -50%)`,
					'transform': 
						`translate(-50%, -50%)`
				});
			}else{
				calligraphyContainer.css({
					'-webkit-transform': 
						`translate(calc(-50% + ${translateOffset[_this.index()]}vw), -50%)`,
					'transform': 
						`translate(calc(-50% + ${translateOffset[_this.index()]}vw), -50%)`
				});
			}
		}

		_this.toggleClass('active')
			.siblings().removeClass('active');
	});
}

function initArticle() {
	const looksFocus = $('#looks-focus');
	const looksWheel = $('#looks-wheel');
	const looksPaginationTotal = parseInt($('#looks-pagination_total').text());
	const looksPaginationCurrent = $('#looks-pagination_current');
	const movePrev = $('[direction="prev"]');
	const moveNext = $('[direction="next"]')
	looksWheelWidth = 0;

	looksWheel.imagesLoaded(function() {
		looksWheel.find('.look').each(function() {
			looksWheelWidth += $(this).width();
		});

		if(looksWheelWidth > looksWheel.width()) {
			html.addClass('looks_overflow')
		}
	}).find('[data-look]').on('click', function() {
		let _this = $(this);
		let count = _this.data('look');
		let lookFocusCount = looksFocus.find(`[data-look="${count}"]`);

		lookFocusCount.addClass('active')
			.siblings().removeClass('active');

		if(!lookFocusCount.hasClass('highres')){
			lookFocusCount.find('img').attr('src', 
				lookFocusCount.attr('data-highres'));
			lookFocusCount.addClass('highres');
		}

		looksPaginationCurrent.text(count);

		if(html.hasClass('looks_overflow')) {
			looksWheelTransformX = 0;

			_this.prevAll().each(function() {
				looksWheelTransformX += $(this).width();
			});

			looksWheel.css({
				'-webkit-transform': `translateX(-${looksWheelTransformX - 60}}px)`,
				'transform': `translateX(-${looksWheelTransformX - 60}px)`
			});
		}

		_this.addClass('active')
			.siblings().removeClass('active');

		if(count === 1) {
			movePrev.removeClass('active');
		}else{
			movePrev.addClass('active')
		}
		if(count === looksPaginationTotal) {
			moveNext.removeClass('active');
		}else{
			moveNext.addClass('active');
		}
	});

	movePrev.on('click', function(e) {
		e.preventDefault();

		looksWheel.find('.active').prev().trigger('click');
	});

	moveNext.on('click', function(e) {
		e.preventDefault();

		looksWheel.find('.active').next().trigger('click');
	});

	looksWheel.find('[data-look]').first().trigger('click');

	if(responsive && looksFocus.length) {
		looksFocus[0].addEventListener('touchstart', handleTouchStart, false);		
		looksFocus[0].addEventListener('touchmove', handleTouchMove, false);

		function getTouches(evt) {
			return evt.touches ||
			evt.originalEvent.touches;
		}

		function handleTouchStart(evt) {
			firstTouch = getTouches(evt)[0];
			xDown = firstTouch.clientX;
			yDown = firstTouch.clientY;
		};

		function handleTouchMove(evt) {
			if ( ! xDown || ! yDown ) {
				return;
			}

			var xUp = evt.touches[0].clientX;
			var yUp = evt.touches[0].clientY;
			var xDiff = xDown - xUp;
			var yDiff = yDown - yUp;
			var slideActive = looksWheel.find('.active').data('look');

			if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
				if ( xDiff > 0 ) {
					if(slideActive < looksPaginationTotal) {
						looksWheel.find(`[data-look="${slideActive + 1}"]`).trigger('click');
					}
				} else {
					if(slideActive - 1 > 0) {
						looksWheel.find(`[data-look="${slideActive - 1}"]`).trigger('click');
					}
				}
			}
			xDown = null;
			yDown = null;
		};
	}
}

function initSpecialProjects() {
	_document.on('click', '#special-project-slide-in', function(e) {
		e.preventDefault();

		main.animate({
			scrollTop: 0
		},300);

		setTimeout(function() {
			html.addClass('special_project_slide');
		}, 300)
	});

	_document.on('click', '#special-project-slide-out', function(e) {
		e.preventDefault();

		html.removeClass('special_project_slide');
	});

	if(responsive) {
		$('#special-project-slide-responsive').append(
			sidebar.find('#special-project-info').clone(),
			sidebar.find('#special-project-slide-in').clone(),
			sidebar.find('#special-project-slide').clone()
		)
	}
}

function initInformationPage() {
	$('#information-content table').each(function() { 
		let table = $(this);
		let tableHeight = table.height();
		let tableCap = !responsive
			? 350
			: 500;
		let tableContent = table.find('.table-content');

		if(!table.find('form').length && tableHeight > tableCap) {
			let tableTop = table.data('stack-scroll');
			let tableP = table.find('p');
			wrapperHtml = '';

			// find p breakpoint:
			tableP.each(function() {
				let p = $(this);

				if(p.offset().top > tableTop + tableCap) {
					wrapperHtml += `<p>${p.html()}</p>`;
					p.remove();
				}
			});

			tableContent.append(`
				<div class="table-expand">${wrapperHtml}</div>
				<button class="table-expand_open">+ Read More</button>
			`);
		}
	});

	_document.on('click', '.table-expand_open', function() {
		$(this).slideUp(150).siblings('.table-expand').slideDown();
	});
}

function initAccount() {
	$('#recover-form_click').on('click', function(e){
		e.preventDefault();
		window.location.hash = '#recover';
		$('#login-form, #account-register-button').fadeOut();
		setTimeout(function(){
			$('#recover-form').fadeIn()
		}, 450);
	});

	if(window.location.hash == '#recover'){
		$('#recover-form_click').trigger('click');
		$('#login-form, #account-register-button').remove();
	}

	$('.order-details_open').on('click', function(event){
		var order = $(this);
		order.siblings('.order-details').slideToggle(200);
	});
}

function initResponsiveSidebar() {
	const headerPull = $('#header-pull');

	headerPull.click(function() {
		html.toggleClass('sidebar_open');
	});

	main.click(function() {
		html.removeClass('sidebar_open')
	});
}


function initBand() {
	$('#mobile-copyright_open').click(function() {
		html.addClass('band_copyright_open');
	});

	_document.click(function(e) {
		let target = $(e.target);

		if(!target.is('#mobile-copyright_open') && !target.closest('#band-content').length) {
			html.removeClass('band_copyright_open');
		}
	});
}
